import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  standalone: false,
})
export class HeaderComponent {
  @Input() title?: string;
  @Input() subtitle?: string;
  @Input() editMode: boolean = false;
}
